<script lang="ts" setup>
import { PropType } from 'vue';
import { Result } from '@/models/results.model';
import { Company } from '@/models/company';

const { result } = defineProps({
  result: {
    type: Object as PropType<Result<Company>>,
    required: true,
  },
});
</script>
<template>
  <li class="search-result">
    <router-link :to="`/company/${result.item.id}`"
      >{{ result.item.name }}
    </router-link>
    <div>
      {{ result.item.description }}
    </div>
  </li>
</template>
